// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1t2sw","header":"PatientQuestionnaire_header__3xEaA","info":"PatientQuestionnaire_info__2wMsc"};